import { IFormatedFlightData } from "@/components/custom/FlightPicker/FlightsSelect/FlightsSelect";
import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { TransportSelectedLabel } from "@/components/custom/AlternativeTransportation/Transportations/TransportSelected/TransportSelectedLabel";
import {
  FlightSearchResult,
  MaterialColors,
  SelectedTransport,
} from "@/core/types/types";
import { getFormattedTime, getFormattedDate } from "@/core/utils";
import { resolveFlightNumber } from "@/services/TransportMapper/TransportMapper";

interface TransportSelectedProps {
  transport: FlightSearchResult | SelectedTransport;
  handleEdit: () => void;
  isSelectedFromList: boolean;
}

const TransportSelected = ({
  transport,
  handleEdit,
  isSelectedFromList,
}: TransportSelectedProps) => {
  // FlightSearchResult can't be mapped into SelectedTransport before, otherwise operatingAirlineName will be lost
  const combinedTransport = transport as FlightSearchResult & SelectedTransport;

  const flightNumber: string = isSelectedFromList
    ? resolveFlightNumber(
        combinedTransport.operatingAirlineCode,
        combinedTransport.flightNumber
      )
    : combinedTransport.flightNumber;

  const formattedFlightData: IFormatedFlightData = {
    formattedDepartureDate: getFormattedDate(
      combinedTransport.scheduledDeparture ??
        combinedTransport.scheduledDepartureDateTime
    )!,
    formattedDepartureTime: getFormattedTime(
      combinedTransport.scheduledDeparture ??
        combinedTransport.scheduledDepartureDateTime
    ),
    formattedArrivalTime: getFormattedTime(
      combinedTransport.scheduledArrival ??
        combinedTransport.scheduledArrivalDateTime
    ),
    formattedFlightNumber: flightNumber,
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box width="100%">
        <TransportSelectedLabel
          key={flightNumber}
          flight={transport}
          formattedFlightData={formattedFlightData}
        />
      </Box>
      <IconButton
        color={MaterialColors.Primary}
        onClick={handleEdit}
        size="large"
      >
        <EditIcon />
      </IconButton>
    </Box>
  );
};

export default TransportSelected;
